import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { action } from '@ember/object';
import DomainModel from 'cio/models/domain';
import ActionsEmailIndexController from 'cio/pods/actions/email/controller';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class ActionsEmailIndexRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Email',
      path: 'actions.email',
    };
  }

  beforeModel() {
    this.store.unloadAll('domain');
  }

  model() {
    return this.store.findAll('domain');
  }

  setupController(controller: ActionsEmailIndexController, model: DomainModel[], transition: Transition) {
    super.setupController(controller, model, transition);

    controller.set('domains', model.toArray());
  }

  @action
  reloadModel() {
    return this.refresh();
  }
}
